<template>
    <section class="odocs-spaced">
        <p>
            <o-button label="Add" size="small" icon-left="plus" />
            <o-button label="Add" icon-left="plus" />
            <o-button label="Add" size="medium" icon-left="plus" />
            <o-button label="Add" size="large" icon-left="plus" />
        </p>

        <p>
            <o-button label="Delete" variant="danger" icon-left="trash" />
            <o-button label="Delete" variant="danger" icon-right="trash" />
            <o-button variant="danger" aria-label="Delete" icon-right="trash" />
        </p>
    </section>
</template>
